import {
  PrimaryCta,
  SecondaryCta,
} from '@rsa-digital/evo-shared-components/components/Cta';
import {
  CtaText,
  IconWrapper,
} from '@rsa-digital/evo-shared-components/components/Cta/styles';
import RichText from '@rsa-digital/evo-shared-components/components/RichText';
import fonts from '@rsa-digital/evo-shared-components/helpers/fonts';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled, { css } from 'styled-components';

type Props = {
  shouldShowCookieNotice: boolean;
};

export const VideoCookieNoticeContainer = styled.div<Props>`
  display: ${(props) => (props.shouldShowCookieNotice ? 'block' : 'none')};
  z-index: 6;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

export const NoticeBackgroundImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  margin: auto;
`;

export const VideoNotAvailableText = styled.div`
  display: none;
  position: absolute;
  top: 5%;
  left: 4%;
  color: white;
  ${fonts.paragraphSmall};

  ${mediaQuery.tabletPortrait`
    display: block;
  `}
`;

export const NoticeContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 85%;
  width: 93%;
  background-color: white;
  padding: 3%;
  box-shadow:
    0 8px 8px 0 rgba(0, 0, 0, 0.8),
    0 8px 32px 0 rgba(0, 0, 0, 0.19);

  ${mediaQuery.tabletPortrait`
    height: 68%;
    width: 85%;
    padding: 4%;
  `}

  ${mediaQuery.tabletLandscape`
    height: 70%;
    width: 85%;
    padding: 3.5%;
  `}
`;

export const NoticeHeading = styled.h3`
  ${fonts.paragraphSmall}
  & {
    font-size: 4.18vw;
    font-weight: bold;
    line-height: 24px;
  }

  margin: 0 0 1.5vw;

  ${mediaQuery.tabletPortrait`  
    ${fonts.headingSmall}  
    & { 
      font-size: 4vw;
      font-weight: 700;
    }
    margin: 0 0 2vw;
  `}

  ${mediaQuery.tabletLandscape`  
    & { 
      font-size: 2.5vw;
      font-weight: 700;
    }
    margin: 0 0 calc(2.3vw - 11.5px);
  `}

  ${mediaQuery.desktop`  
    & { 
      font-size: 28px;
      font-weight: 700;
    }
    margin: 0 0 ${spacing(2)};
  `}
`;

export const NoticeBody = styled(RichText)`
  ${fonts.paragraphSmall};
  & {
    font-size: 3.2vw;
    line-height: 5vw;
  }

  ${mediaQuery.tabletPortrait`  
    font-size: 2.75vw;
    line-height: 30px;
  `}

  ${mediaQuery.tabletLandscape`  
    font-size: calc(1.43vw + 2.8px);
    line-height: calc(3.15vw - 5.8px);
  `}

  ${mediaQuery.desktop`
    font-size: 20px;
    line-height: 32px;
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const CommonCtaStyle = css`
  padding: 7px 13px;
  height: ${spacing(4.5)};

  ${mediaQuery.tabletPortrait`
    padding: ${spacing(2)} ${spacing(3)};
    height: calc(9.2vw - 13.25px);
  `}

  ${mediaQuery.tabletLandscape`
    padding: ${spacing(1.5)} ${spacing(2.5)};
    height: calc(3.44vw + 22.77px);
  `}

  ${mediaQuery.desktop`
    padding: ${spacing(1.5)} ${spacing(2.5)};
    height: ${spacing(8)};
  `}

  ${CtaText} {
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;

    ${mediaQuery.tabletPortrait`
      font-size: 20px;
    `}

    ${mediaQuery.tabletLandscape`
      font-size: 16px;
    `}

    ${mediaQuery.desktop`
        font-size: 20px;
        line-height: 32px;
    `}
  }
`;

export const HiddenOneTrustButton = styled.button`
  position: absolute;
  ${CommonCtaStyle};
  opacity: 0;

  & {
    min-width: 142px;

    ${mediaQuery.tabletPortrait`
      min-width: 213px;
    `}

    ${mediaQuery.tabletLandscape`
      min-width: 179px;
    `}

    ${mediaQuery.desktop`
      min-width: 209px;
    `}
  }
`;

export const ManageCta = styled(SecondaryCta)`
  ${CommonCtaStyle};
  & {
    padding-right: ${spacing(1.5)};
  }

  ${IconWrapper} {
    margin-left: ${spacing(1)};
  }
`;

export const AcceptCta = styled(PrimaryCta)`
  ${CommonCtaStyle};

  ${IconWrapper} {
    display: none;
  }
`;
